// src/SliderWithLargeImage.js
import React, {useEffect, useState} from 'react';
import VerticalSlider from './VerticalSlider';
import ProductDetails from './ProductDetails';
import ProductInformation from './ProductInformation';
import Product from './Product';

import '../../style/PimViewer.scss';

const PimViewer = (props) => {

    const { values, classes, setShowMiniCart, handleFavoriteQuantityChange, favorite  } = props;
    const [product, setProduct] = useState(null);

    const visibilityClasses = [
        !values.displayDeviceLg && "hidden-lg",
        !values.displayDeviceMd && "hidden-md",
        !values.displayDeviceSm && "hidden-sm",
        !values.displayDeviceXs && "hidden-xs",
    ]
        .filter(Boolean)
        .join(" ");

    useEffect(() => {
        fetch('/Api/System/Pim/IndexManager/Product?sku=' + values.sku)
            .then((res) => res.json())
            .then((product) => {
                setProduct(product);
            });
    }, [])

    return (
        <>
            <div className={`pim-viewer ${visibilityClasses}`}>
                <div className="row m-0 justify-content-center">
                    {/* Image Slider */}
                    <div className="col-lg-5 col-md-12 col-sm-12">
                        {product && (
                            <VerticalSlider
                                images={product.images}
                            />
                        )}
                    </div>

                    {/* Product Details & Information */}
                    <div className="col-lg-4 col-md-12 col-sm-12">
                        {product && <ProductDetails product={product} setShowMiniCart={setShowMiniCart} handleFavoriteQuantityChange={handleFavoriteQuantityChange} favorite={favorite}/>}
                        {product && <ProductInformation product={product} />}
                    </div>
                </div>

            </div>
        </>


    );
};

export default PimViewer;
